/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import qs from 'qs'; // 根据需求是否导入qs模块

import VueCookies from 'vue-cookies'
import axios from 'axios';
import router from '../router';
//import store from '../store/index';
import {
  Toast
} from 'vant';

/** 
 * 提示函数 
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  // Toast({
  //     message: msg,
  //     duration: 1000,
  //     forbidClick: true
  // });
}

/** 
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
}

/** 
 * 请求失败后的错误统一处理 
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    // case 401:
    //     toLogin();
    //     break;
    // 403 token过期
    // 清除token并跳转登录页
    // case 403:
    //     tip('登录过期，请重新登录');
    //     // localStorage.removeItem('token');
    //     // store.commit('loginSuccess', null);
    //     setTimeout(() => {
    //         toLogin();
    //     }, 1000);
    //     break;
    // 404请求不存在
    // case 404:
    //     tip('请求的资源不存在');
    //     router.replace({
    //         path: '/notFound',
    //         query: {
    //             redirect: router.currentRoute.fullPath
    //         }
    //     });
    //     break;
    // case 504:
    //     tip('请求超时，请稍后再试');
    //     console.log('请求超时504');
    //     console.log(router.currentRoute);
    //     router.push({
    //         path: '/netError',
    //         // query: {
    //         //     redirect: router.currentRoute.fullPath
    //         // }
    //     });
    // case 500:
    //     tip('服务器错误');
    //     console.log('500服务器错误');
    //     console.log(router.currentRoute);
    //     router.push({
    //         path: '/netError',
    //         // query: {
    //         //     redirect: router.currentRoute.fullPath
    //         // }
    //     });
    // break;
    //     case 504:
    //     tip('请求超时，请稍后再试');
    //     console.log('504请求超时');
    //     console.log(router.currentRoute);
    //     router.push({
    //         path: '/netError',
    //         // query: {
    //         //     redirect: router.currentRoute.fullPath
    //         // }
    //     });
    // break;
    default:
      //console.log(other);
  }
}

// 创建axios实例
var instance = axios.create({
  timeout: 5000 * 1000
});
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/** 
 * 请求拦截器 
 * 每次请求前，如果存在token则在请求头中携带token 
 */
instance.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况        
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token        
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码        
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。        
    // const token = store.state.token;        
    // token && (config.headers.Authorization = token);
    let storeInfo = VueCookies.get('storeInfo')

    if (config.method === 'post') {
      // qs 默认 parameterLimit=1000、arrayLimit=20，长数组（如批量删除购物车 id）会被截断
      let data = qs.parse(config.data, { parameterLimit: Infinity, arrayLimit: Infinity })
      if (storeInfo) {
        data.storeNo = storeInfo.storeNo
      }
      config.data = qs.stringify({
        ...data
      })

    } else if (config.method === 'get') {
      let data = config.params
      if (storeInfo) {
        data.storeNo = storeInfo.storeNo
      }
      config.params = {
        ...data
      }
    }
    return config;
  },
  error => Promise.error(error))

// // 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
  // 请求失败
  error => {
    const {
      response
    } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围 
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明

      // store.commit('changeNetwork', false);
    }
  });

export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js